/**
 * THE DEBUG FLAG: dev chrome (the Event Inspector pill) shows only when asked for.
 * `?debugEvents=1` on the URL (this load only) or `localStorage pmt.debug = '1'`
 * (this browser, until cleared). A DEV build does NOT turn it on by itself: the iPad
 * is driven against the dev server, and a default-on pill sat on the work surface of
 * every review session (UI-FINAL, U1: "EventInspector gated, also in DEV").
 *
 * Pure over its inputs so the gate is unit-testable; `debugFlagOn()` reads the page.
 */
export const DEBUG_STORAGE_KEY = 'pmt.debug';

export function debugFlagFrom(search: string, storedValue: string | null): boolean {
    try {
        if (new URLSearchParams(search).get('debugEvents') === '1') return true;
    } catch {
        // a malformed query string is "no flag"
    }
    return storedValue === '1';
}

/** The flag for this page (URL param, else localStorage); false off the browser or with storage blocked. */
export function debugFlagOn(): boolean {
    if (typeof window === 'undefined') return false;
    let stored: string | null = null;
    try {
        stored = window.localStorage.getItem(DEBUG_STORAGE_KEY);
    } catch {
        // storage blocked: the URL flag still works for this load
    }
    return debugFlagFrom(window.location.search, stored);
}
